module.exports = __webpack_public_path__ + "static/media/PM127.d804b885.png";